import { globalService as gs } from "./global.service";
import axios from 'axios';
import { uploadSelectors } from "../redux/selectors";

const item = (params = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/item/${gs.identity ? 'index' : 'public-index'}`);
    url = (params !== null) ? gs.requestParams(url, params) : url;
    return gs.request(url, gs.requestOptions("GET", null));
};

const countries = (method = "GET", params = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/countries`);
    url = (params !== null) ? gs.requestParams(url, params) : url;
    return gs.request(url, gs.requestOptions(method, params));
};

const states = (params = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/states`);
    url = (params !== null) ? gs.requestParams(url, params) : url;
    return gs.request(url, gs.requestOptions("GET", null));
};

const newsletter = (params = null, params2 = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/newsletter`);
    url = (params2 !== null) ? gs.requestParams(url, params2) : url;
    return gs.request(url, gs.requestOptions("POST", params));
};

const timeZone = (method = "GET", params = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/timezone`);
    url = (params !== null) ? gs.requestParams(url, params) : url;
    return gs.request(url, gs.requestOptions(method, params));
};

const contact = (params = null, params2 = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/contact`);
    url = (params2 !== null) ? gs.requestParams(url, params2) : url;
    return gs.request(url, gs.requestOptions("POST", params));
};

// Image upload service
const deleteFile = (params = null, params2 = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/delete-file`);
    url = (params2 !== null) ? gs.requestParams(url, params2) : url;
    return gs.request(url, gs.requestOptions("DELETE", params));
};

const autocomplete = (params = null, item = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/${item}-autocomplete`);
    url = (params !== null) ? gs.requestParams(url, params) : url;
    return gs.request(url, gs.requestOptions("GET", null));
};

const categories = (params = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/user-catalog/${gs.identity ? 'categories' : 'public-categories'}`);
    url = (params !== null) ? gs.requestParams(url, params) : url;
    return gs.request(url, gs.requestOptions("GET", null));
};

const userCategories = (params = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/user-catalog/categories`);
    url = (params !== null) ? gs.requestParams(url, params) : url;
    return gs.request(url, gs.requestOptions("GET", null));
};

const skills = (params = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/skills`);
    url = (params !== null) ? gs.requestParams(url, params) : url;
    return gs.request(url, gs.requestOptions("GET", null));
};

const questions = (params = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/questions`);
    url = (params !== null) ? gs.requestParams(url, params) : url;
    return gs.request(url, gs.requestOptions("GET", null));
};

const platforms = (params = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/platforms`);
    url = (params !== null) ? gs.requestParams(url, params) : url;
    return gs.request(url, gs.requestOptions("GET", null));
};

const notification = (method = "GET", params = null, params2 = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/notifications`);
    url = (params2 !== null) ? gs.requestParams(url, params2) : url;
    return gs.request(url, gs.requestOptions(method, params));
};

const coreField = (params = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/core-field-options`);
    url = (params !== null) ? gs.requestParams(url, params) : url;
    return gs.request(url, gs.requestOptions("GET", null));
};

const fields = (params = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/fields`);
    url = (params !== null) ? gs.requestParams(url, params) : url;
    return gs.request(url, gs.requestOptions("GET", null));
};

// const coupons = (method = "POST", params = null, params2 = null) => {
//     let url = 'https://api.k12tutorconnect.com/user/public-coupons';
//     url = (params2 !== null) ? gs.requestParams(url, params2) : url;
//     return gs.request(url, gs.requestOptions(method, params));
// };

const coupons = (method = "POST", params = null, params2 = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/user/${gs.identity ? 'coupons' : 'public-coupons'}`);
    url = (params2 !== null) ? gs.requestParams(url, params2) : url;
    return gs.request(url, gs.requestOptions(method, params));
};

const config = (params2 = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/config`);
    url = (params2 !== null) ? gs.requestParams(url, params2) : url;
    return gs.request(url, gs.requestOptions("GET", null));
};

const resubmitVerification = (method = "GET", params = null, params2 = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/user/resubmit-verification`);
    url = (params2 !== null) ? gs.requestParams(url, params2) : url;
    return gs.request(url, gs.requestOptions(method, params));
};

const packages = (method = "GET", params = null, params2 = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/${gs.identity ? 'packages' : 'publicpackages'}`);
    url = (params2 !== null) ? gs.requestParams(url, params2) : url;
    return gs.request(url, gs.requestOptions(method, params));
};

const schools = (method = "GET", params = null, params2 = null) => {
    let url = gs.httpURL(`${gs.apiRoot}/default/${gs.identity ? 'schools' : 'publicschools'}`);
    url = (params2 !== null) ? gs.requestParams(url, params2) : url;
    return gs.request(url, gs.requestOptions(method, params));
};

// Image upload service
const uploadFile = (files) => {
    const formData = new FormData();
    Array.from(files).forEach(f => formData.append('file[]', f));
    return fetch(`${gs.apiRoot}/default/upload`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${gs.authToken()}` },
        body: formData
    })
        .then(
            response => {
                if (!response.ok) {
                    throw response
                }
                return response.json();
            });
};

const uploadWithoutProgress = (files) => {
    const formData = new FormData();
    Array.from(files).forEach(f => formData.append('file[]', f));
    let url = gs.httpURL(`${gs.apiRoot}/default/${gs.identity ? 'upload' : 'unsecured-upload'}`);
    return fetch(url, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${gs.authToken()}` },
        body: formData
    })
        .then(
            response => {
                if (!response.ok) {
                    throw response
                }
                return response.json();
            });
};

const uploadAndProgress = (files, dispatch) => {
    const formData = new FormData();
    Array.from(files).forEach(f => formData.append('file[]', f));
    return axios.request({
        method: "post",
        url: `${gs.apiRoot}/default/upload`,
        headers: { 'Authorization': `Bearer ${gs.authToken()}` },
        data: formData,
        onUploadProgress: (p) => {
            let progress = calcProgressPercent(p);
            dispatch && dispatch(uploadSelectors.progress(progress));
        }
    }).then(
        response => {
            if (response.status !== 200) {
                throw response
            }
            return response.data;
        })
};

const calcProgressPercent = (event) => {
    let progress = Math.round(100 * event.loaded / event.total);
    return progress
};


export const defaultService = {
    item,
    countries,
    states,
    timeZone,
    contact,
    autocomplete,
    uploadFile,
    deleteFile,
    uploadWithoutProgress,
    uploadAndProgress,
    calcProgressPercent,
    categories,
    userCategories,
    skills,
    questions,
    platforms,
    coreField,
    fields,
    newsletter,
    notification,
    coupons,
    config,
    resubmitVerification,
    packages,
    schools,
};
